import axios from 'axios';
import Utils from '../utils/Utils';


const apiUrl = process.env.REACT_APP_API_URL || '';
const URLcities = apiUrl ? `${apiUrl}/public/cities` : `/api/local/public/cities`;
const URLorganizationProjects = apiUrl ? `${apiUrl}/public/organizations/project` : `/api/local/public/organizations/project`;
const URLcreateVolunteerToProject = apiUrl ? `${apiUrl}/public/volunteers/project` : `/api/local/public/volunteers/project`;
const URLcreateVolunteer = apiUrl ? `${apiUrl}/public/volunteers` : `/api/local/public/volunteers`;

// Add retry interceptor
axios.interceptors.response.use(null, async (error) => {
  console.log("in the interceptor")
  const { config } = error;
  
  // If config doesn't exist or the retry option is not set, reject
  if (!config || !config.retry) {
      return Promise.reject(error);
  }

  // Set the variable for keeping track of the retry count
  config.__retryCount = config.__retryCount || 0;

  
  // Check if we've maxed out the total number of retries
  if (config.__retryCount >= config.retry) {
      // Reject with the error
      return Promise.reject(error);
  }

  // Increase the retry count
  config.__retryCount += 1;

  // Create new promise to handle exponential backoff
  const backoff = new Promise((resolve) => {
      setTimeout(() => {
          resolve();
      }, config.retryDelay || 1000);
  });

  // Return the promise in which recalls axios to retry the request
  await backoff;
  return axios(config);
});

const getCities = async () => {
  return await Utils.getItems(URLcities)
}

const getOrganizationProjects = async () => {
  return await Utils.getItems(URLorganizationProjects)
}

const createVolunteerForProject = async (projectId, volunteerData) => {
  return await Utils.addItemPost(`${URLcreateVolunteerToProject}/${projectId}`, volunteerData)
}

const createVolunteer = async (volunteerData) => {
  return await Utils.addItemPost(`${URLcreateVolunteer}`, volunteerData)
}

export default {
  getCities,
  getOrganizationProjects,
  createVolunteerForProject,
  createVolunteer
}